﻿window.cObjetFile = function (data, bddRef) {
    var Me = this;
    this.data = data
    this.isDirectory = false
    var extension = null
    if (data.id_fichier == null) { extension = data.extension }
    else {
        if (data.id_fichier.endsWith("/") || data.id_fichier.endsWith(".repertoire")) { this.isDirectory = true } //".repertoire" pour la corbeille
        else { extension = data.id_fichier.substring(data.id_fichier.lastIndexOf(".") + 1) }
    }

    function mGetFichier() {
        return new cFichier(bddRef, ((Me.data.id_fichier == null) ? Me.data.extension : Me.data.id_fichier), data.taille_octet, data.dcr, data.dmo)
    }

    var objetFichier = null
    switch (extension) {
        case "emlz": objetFichier = new cObjetFichierEmlzMetier(Me, bddRef); break;
        case "formz": objetFichier = new cObjetFichierFormzMetier(Me, bddRef); break;
        case "docz": objetFichier = new cObjetFichierDoczMetier(Me, bddRef); break;
        case "dcptz": objetFichier = new cObjetFichierDcptzMetier(Me, bddRef); break;
    }

    //this.mGetPopupPositionWidthHeight = function () {
    //    if (typeof Me.bddRef.utiCourantParaJson.popupsize == 'undefined') Me.bddRef.utiCourantParaJson.popupsize = {}
    //    if (typeof Me.bddRef.utiCourantParaJson.popupsize[this.mGetTable().nom] != 'undefined') {
    //                return bddRef.utiCourantParaJson.popupsize[this.mGetTable().nom]
    //    } else {
    //            return {
    //                width: "650",
    //                maxWidth: "calc(100% - 60px)",
    //                height: "calc(100% - 90px)",
    //                maxHeight: "calc(100% - 50px)",
    //                position: {
    //                    my: "right top",
    //                    at: "right top",
    //                    of: "body",
    //                    offset: { x: -30, y: 65 }
    //                }
    //            }
    //    }
    //}
    //this.mSavePopupPositionWidthHeight = function (width, height) {
    //    if (typeof Me.bddRef.utiCourantParaJson.popupsize == 'undefined') Me.bddRef.utiCourantParaJson.popupsize = {}
    //    var popupPositionWidthHeight = this.mGetPopupPositionWidthHeight()
    //    popupPositionWidthHeight.width = width
    //    popupPositionWidthHeight.height = height
    //    switch (this.mGetTable().nom) {
    //        case "structures": case "structures_contact":
    //            bddRef.utiCourantParaJson.popupsize["structures"] = popupPositionWidthHeight
    //            break;
    //        default:
    //            bddRef.utiCourantParaJson.popupsize[this.mGetTable().nom] = popupPositionWidthHeight
    //            break;
    //    }
    //    bddRef.mSaveParaJsonUtilisateur();
    //}

    this.mGetTable = function () {
        return {
            nom: "fichier",
            id_table: "0"
        }
    }

    this.cle = function () {
        return data.id_fichier
    }

    this.mGetLibBase = function () {
        return ((this.isDirectory) ? "Répertoire" : ((objetFichier == null) ? "Document" : objetFichier.mGetLibBase()));
    }
    this.mGetAttributBase = function () { return ((objetFichier == null) ? "le " : objetFichier.mGetAttributBase()); }
    this.mGetNewLib = function () {
        return ((this.isDirectory) ? "Nouveau répertoire" : ((objetFichier == null) ? "Nouveau document" : objetFichier.mGetNewLib()));
    }
    this.mGetLib1 = function (option) {
        var txt =  mGetFichier().mGetLib1()
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
        //var txt = ""
        //if (typeof this.data != 'undefined') {
        //    if (this.data.id_nom_fichier != null) {
        //        if (this.isDirectory) {
        //            var directory = this.data.id_nom_fichier
        //            if (directory.endsWith(".repertoire")) {
        //                directory = directory.substring(0, directory.length - ".repertoire".length)
        //            } else {
        //                directory = directory.substring(0, this.data.id_nom_fichier.length - 1)
        //            }
        //            //var directory = this.data.id_nom_fichier.substring(0, this.data.id_nom_fichier.length - 1)
        //            txt = directory.substring(directory.lastIndexOf("/") + 1)
        //        } else {
        //            txt = this.data.id_nom_fichier.substring(this.data.id_nom_fichier.lastIndexOf("/") + 1)
        //        }
        //    }
        //    else { txt = ((objetFichier == null) ? this.mGetLibBase() : objetFichier.mGetLibBase()); }
        //} else { txt = ((objetFichier == null) ? this.mGetLibBase() : objetFichier.mGetLibBase()); }
        //return txt
    }
    this.mGetLib2 = function () {
        return mGetFichier().mGetLib2()
        //if (typeof this.data == 'undefined' || typeof this.data.id_nom_fichier == 'undefined') { return "" }
        //else {
        //    var nom = ""
        //    if (this.isInCorbeille()) { return "/Corbeille" }
        //    else if (this.isInBrouillon()) { return this.mGetPathDocument().substring(this.mGetPathDocument().indexOf("/")) }
        //    else { return this.mGetPathDocument() }
        //    //else if (this.isInBrouillon()) { return "/Vos documents" }
        //    //else {
        //    //    if (this.data.id_nom_fichier.endsWith("/")) {
        //    //        nom = this.data.id_nom_fichier.substring(0, this.data.id_nom_fichier.length - 1)
        //    //        nom = nom.substring(0, nom.lastIndexOf("/"))
        //    //    } else {
        //    //        nom = this.data.id_nom_fichier.substring(0, this.data.id_nom_fichier.lastIndexOf("/"))
        //    //    }
        //    //    return nom.substring(this.repertoireRacine.substring(1).length + 1)
        //    //}
        //}
    }

    this.mGetImageData = function () {
        return this.mGetIcone()
    }
    this.mGetIcone = function (container) {
        return mGetFichier().mGetIcone(container)
        //if (objetFichier == null) {
        //    var fic = new cFichier(bddRef, this.data.id_nom_fichier)
        //    if (typeof container == 'undefined') { return fic.mGetElementImage() }
        //    else { return fic.mGetElementImage(container.innerHeight(), container.innerWidth()) }
        //} else { return objetFichier.mGetIcone(container) }
    }

    this.itemTemplateGrille = function (contentElement, type) {
        return mGetFichier().itemTemplateGrille(contentElement, type)
        //var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        //var $Tr = $("<tr/>").appendTo($Table)
        //var $Td = $("<td style='width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'/>").appendTo($Tr)
        //if (this.isDirectory) {
        //    $Td.css({
        //        "font-size": "180%",
        //        "font-variant": "small-caps",
        //        "font-weight":500
        //    })
        //    contentElement.css({  "border": "1px dotted " + theme.color })
        //}
        //$Td.text(Me.mGetLib1())
        //$Td.attr("title", Me.mGetLib1())

        //if (typeof this.data.taille_octet != 'undefined' && !this.isDirectory) {
        //    var $Td = $("<td style='font-family:barlow condensed;width:100px;text-align:right;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:80%;font-variant:" + ((this.isDirectory) ? "small-caps" : "normal") + ";opacity:0.5;vertical-align:top;'>" + this.data.taille_octet.sizeFile() + "</td>").appendTo($Tr)
        //}
    }
    this.itemTemplateGrillePlus = function (contentElement, option) {
        return mGetFichier().itemTemplateGrillePlus(contentElement, option)
        //var $Span = $("<span style='font-family:barlow condensed;'></span>").appendTo(contentElement)
        //var $A = $("<a href='javascript:void(0)'>" + Me.mGetPathDocument() + "</a>").appendTo($Span)
        //$A.on("click", function (e) {
        //    e.stopPropagation()
        //    option.onClickRepertoire(Me.mGetPath())
        //})
        //$("<span> &bull; Créé " + Me.data.dcr.toDateIlya(true) + " (" + Me.data.dcr.toFrenchDateTime() + ") &bull; Modifié " + Me.data.dmo.toDateIlya(true) + " (" + Me.data.dmo.toFrenchDateTime() + ")</span>").appendTo($Span)
    }


    this.mHasTabPopup = function () {
        return true
    }
    this.mGetWidthPopup = function () {
        return 650
    }
    this.isPopupFullScreen = true
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    option.fullScreen = false
    //    page.mAddPopup(data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        if (objetFichier && typeof objetFichier.contentTemplatePopup != 'undefined') { objetFichier.contentTemplatePopup(contentElement, option) }
        else {
            var nomFichier = ((this.data.id_fichier.startsWith("~")) ? this.data.id_fichier.substring(1) : this.data.id_fichier)
            switch (extension.toLowerCase()) {
                case "png": case "bmp": case "jpg": case "jpeg": case "gif": case "tif":
                    if (option.readOnly) {
                        $("<div/>").appendTo(contentElement).dxCtrlViewer({
                            value: this.data.id_fichier,
                            autoriseModif: false,
                            inPopup: false,
                            bddCtrl: bddRef
                        }).dxCtrlViewer("instance")
                    } else {
                        $("<div style='height:100%;'/>").appendTo(contentElement).dxCtrlImageEditor({
                            value: nomFichier
                        }).dxCtrlImageEditor("instance")
                    }
                    break;
                case "jsonz":
                    $("<div/>").appendTo(contentElement).dxCtrlImportFichierJson({
                        bddCtrl: bddRef,
                        value: this.data.id_fichier,
                        onClose: function () {
                            option.popupPage.mDestroy()
                        }
                    })
                    break;
                default:
                    $("<div/>").appendTo(contentElement).dxCtrlViewer({
                        value: this.data.id_fichier,
                        autoriseModif: false,
                        inPopup: false,
                        bddCtrl: bddRef
                    }).dxCtrlViewer("instance")
                    break;
            }
        }
    }

    this.mDelData = function (funcOk) {
        if (this.data.id_fichier == null) return;
        var objLstLigne = this.data.id_fichier
        bddRef.mAjaxCall({
            command: "filemanager_traitement",
            action: "corbeille",
            pathnom: objLstLigne
        }, function (data) {
            bddRef.triggerFunctionOnModifiedItemData("fichier", "supp", Me.data)
            if (typeof funcOk != 'undefined') funcOk()
        }, function () {
        }, function () {
            mKo()
        });
    }

    this.mGetNom = function () {
        return mGetFichier().mGetNom()
        //if (this.data.id_nom_fichier.startsWith("data:")) {
        //    var deb = this.data.id_nom_fichier.split(";")[0]
        //    var extension = deb.split("/")[1].toLowerCase();
        //    return "image." + extension
        //} else {
        //    return this.data.id_nom_fichier.substring(this.data.id_nom_fichier.lastIndexOf("/") + 1)
        //}
    }
    this.mGetNomWithoutExtension = function () {
        return mGetFichier().mGetNomWithoutExtension()
        //var nom = this.mGetNom()
        //if (nom.contains(".")) nom = nom.substring(0, nom.lastIndexOf("."))
        //return nom
    }
    this.mGetExtension = function () {
        return mGetFichier().mGetExtension()
        //var extension = this.mGetNom()
        //if (extension.contains(".")) { extension = extension.substring(extension.lastIndexOf(".")) }
        //else { extension = "" }
        //return extension
    }
    this.mGetPath = function () {
        return mGetFichier().mGetPath()
        //if (this.data.id_nom_fichier.startsWith("data:")) {
        //    return ""
        //} else {
        //    return this.data.id_nom_fichier.substring(0, this.data.id_nom_fichier.lastIndexOf("/"))
        //}
    }
    this.mGetPathDocument = function () {
        return mGetFichier().mGetPathDocument()
        //var path = this.mGetPath()
        //if (path.startsWith("~")) path = path.substring(1)
        //path = path.substring(("/fichier/" + bddRef.nom_base).length)
        //if (this.isInBrouillon()) {
        //    path = path.substring(("/" + bddRef.utiCourant.id_utilisateur).length)
        //    path = path.substring(("/documents").length) + "/Vos documents"
        //}
        //return path
    }

    this.isInCorbeille = function () {
        return mGetFichier().isInCorbeille()
        //var idFichier = this.data.id_nom_fichier
        //if (idFichier.startsWith("~")) idFichier = idFichier.substring(1)
        //return idFichier.startsWith(this.repertoireCorbeille.substring(1))
    }
    this.isInBrouillon = function () {
        return mGetFichier().isInBrouillon()
        //var idFichier = this.data.id_nom_fichier
        //if (idFichier.startsWith("~")) idFichier = idFichier.substring(1)
        //return idFichier.startsWith(this.repertoireBrouillon.substring(1))
    }
    this.isInDocumentPartage = function () {
        return mGetFichier().isInDocumentPartage()
    }
    this.isInDocumentPublic = function () {
        return mGetFichier().isInDocumentPublic()
    }


    this.mGetShowTitlePopup = function () {
        return true
    }
    this.mGetWidthPopup = function () {
        return 800
    }
    this.mGetPaddingPopup = function () {
        return 15
    }

    this.objetMetier = {}
    this.objetMetier.mGetTableUpdateLib = function () { return [] }

    //this.mGetPopupPositionWidthHeight = function () {
    //    return {
    //        width: "650",
    //        maxWidth: "calc(100% - 60px)",
    //        height: "calc(100% - 90px)",
    //        maxHeight: "calc(100% - 50px)",
    //        position: {
    //            my: "right top",
    //            at: "right top",
    //            of: "body",
    //            offset: { x: -30, y: 65 }
    //        }
    //    }
    //}
    this.mGetDisplayInPopup = function (newValue) {
        if (typeof bddRef.utiCourantParaJson["dataDisplayInPopup_" + this.mGetTable().nom] == 'undefined') {
            bddRef.utiCourantParaJson["dataDisplayInPopup_" + this.mGetTable().nom] = false
        }
        if (typeof newValue != 'undefined') {
            bddRef.utiCourantParaJson["dataDisplayInPopup_" + this.mGetTable().nom] = newValue
            bddRef.mSaveParaJsonUtilisateur();
        }
        return bddRef.utiCourantParaJson["dataDisplayInPopup_" + this.mGetTable().nom]
    }

    this.mGetPopupPositionWidthHeight = function () {
        if (typeof bddRef.utiCourantParaJson.popupsize == 'undefined') bddRef.utiCourantParaJson.popupsize = {}
        if (typeof bddRef.utiCourantParaJson.popupsize[this.mGetTable().nom] != 'undefined') {
            return bddRef.utiCourantParaJson.popupsize["fichier" + extension]
        } else {
            if (extension == "dcptz") {
                return {
                    width: "600",
                    maxWidth: "calc(100% - 60px)",
                    height: "500",
                    maxHeight: "calc(100% - 50px)",
                    position: {
                        my: "right bottom",
                        at: "right bottom",
                        of: "body",
                        offset: { x: -50, y: -25 }
                    }
                }
            } else {
                return {
                    width: "calc(100% - 60px)",
                    maxWidth: "calc(100% - 60px)",
                    height: "calc(100% - 90px)",
                    maxHeight: "calc(100% - 50px)",
                    position: {
                        my: "right top",
                        at: "right top",
                        of: "body",
                        offset: { x: -30, y: 65 }
                    }
                }
            }
        }
    }
    this.mSavePopupPositionWidthHeight = function (width, height) {
        if (typeof bddRef.utiCourantParaJson.popupsize == 'undefined') bddRef.utiCourantParaJson.popupsize = {}
        var popupPositionWidthHeight = this.mGetPopupPositionWidthHeight()
        popupPositionWidthHeight.width = width
        popupPositionWidthHeight.height = height
        bddRef.utiCourantParaJson.popupsize["fichier" + extension] = popupPositionWidthHeight
        bddRef.mSaveParaJsonUtilisateur();
    }

    this.mGetDisplayInPopup = function (newValue) {
        var valDefault = true
        switch (extension) {
            case "emlz": valDefault = true; break;
            case "docz": valDefault = true; break;
            case "dcptz": valDefault = false; break;
        }
        var nomParaJson = "dataDisplayInPopup_" + extension + "_fichier"
        if (typeof bddRef.utiCourantParaJson[nomParaJson] == 'undefined') {
            bddRef.utiCourantParaJson[nomParaJson] = valDefault
        }
        if (typeof newValue != 'undefined') {
            bddRef.utiCourantParaJson[nomParaJson] = newValue
            bddRef.mSaveParaJsonUtilisateur();
        }
        return bddRef.utiCourantParaJson[nomParaJson]
    }

    return this;
}